'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  'full-time': '242',
  'part-time': '243',
  'contract-temp': '244',
  'casual-vacation': '245'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/hierarchy/work-type-hierarchy.js
 ** module id = 540
 ** module chunks = 0
 **/